export const NAME = "paymentTransactions"
export const FIREBASE_PATH_PAYMENT_TRANSACTIONS = "paymentTransactions"
